import React, {useState, useEffect} from 'react';
import {Modal} from 'semantic-ui-react'
import { useDispatch, useSelector } from 'react-redux';
import Chartkick, { LineChart } from 'react-chartkick'
import Highcharts from 'highcharts'
import {CardDetailActions} from '../../actions/CardDetailAction'

Chartkick.use(Highcharts)

const PriceHistory = (props) => {
    const [open, setOpen] = useState(false)
    const [graphData, setGraphData] = useState({})
    const dispatch = useDispatch();
    const cardGrid = useSelector(state => state.cardGrid)

    useEffect(() => {
        if (props.cardLabel !== '' && open) {
            dispatch(CardDetailActions.fetchPriceHistory(props.cardLabel, props.cardGrade))
        }
    }, [dispatch, props.cardGrade, props.cardLabel, open]);

    useEffect(() => {
        if (cardGrid.selectedCard && cardGrid.cardGridData[cardGrid.selectedCard].price && cardGrid.cardGridData[cardGrid.selectedCard].price > 0) {
            let currPriceObj = {}
            currPriceObj[cardGrid.cardGridData[cardGrid.selectedCard].createdAt] = cardGrid.cardGridData[cardGrid.selectedCard].price
            currPriceObj["2019-01-01"] = cardGrid.cardGridData[cardGrid.selectedCard].price
            let data = [
                {"name":"Your Purchase", "data": currPriceObj},
                {"name":"Historical Prices", "data": cardGrid.priceData ? cardGrid.priceData.queryData : {}}
              ];
              console.log(JSON.stringify(data))
              setGraphData(data)  
        }
        else {
            setGraphData(cardGrid.priceData ? cardGrid.priceData.queryData : {})
        }
    }, [cardGrid.priceData, cardGrid.cardGridData, cardGrid.selectedCard]);

    const renderTriggerButton = () => {
        return <button className="ui inverted green button">Show Price Details</button>
    }

    return (
        <Modal
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={open}
        trigger={renderTriggerButton()}
        >

        <Modal.Header>Card Price History</Modal.Header>
            <Modal.Content >{props.cardLabel} - {props.cardGrade}
             <LineChart data={graphData} />
            </Modal.Content>
        </Modal>
    )
}
export default PriceHistory